import messages from '../../../locales/messages';
import { Link, ClickableTile } from 'carbon-components-react';
import './learnMore.scss';
import { ArrowRight32 } from '@carbon/icons-react';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';

type TilesProps = {
  functionToExecute: () => void;
  id: string;
  className: string;
  bodyText: string;
};

const LMTile = ({ functionToExecute, id, className, bodyText }: TilesProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <ClickableTile
        className="LMTile"
        role="button"
        onClick={() => {
          functionToExecute();
        }}
      >
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sd-4">
            <p className="textSubTile">{useTranslation(bodyText)}</p>
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sd-4">
            <Link
              role="button"
              className="bx-link-class arrowIMG"
              id="se-next-step-id"
              rel="noreferrer"
              renderIcon={() => <ArrowRight32 className="Image" />}
              onClick={() => {
                console.log('Learn More');
                functionToExecute();
              }}
            />
          </div>
        </div>
      </ClickableTile>
    </>
  );
};

type LearnMoreProps = {
  customerQuote: () => void;
  integrations: () => void;
  digitalLabor: () => void;
  experienceProducts: () => void;
};
export const LearnMore = ({
  customerQuote,
  integrations,
  digitalLabor,
  experienceProducts,
}: LearnMoreProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
        <div className="bx--row">
          <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
            <p>{useTranslation('learnMore_subtitle')}</p>
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-4 bx--col-md-2 bx--col-sm-4">
            <LMTile
              id="01"
              className="HH"
              bodyText="learnMore_tile01_text"
              functionToExecute={digitalLabor}
            />
          </div>
          <div className="bx--col-lg-4 bx--col-md-2 bx--col-sm-4">
            <LMTile
              id="01"
              className="HH"
              bodyText="learnMore_tile02_text"
              functionToExecute={customerQuote}
            />
          </div>
        </div>
        <div className="bx--row">
          <div className="bx--col-lg-4 bx--col-md-2 bx--col-sm-4">
            <LMTile
              id="01"
              className="HH"
              bodyText="learnMore_tile03_text"
              functionToExecute={integrations}
            />
          </div>
          <div className="bx--col-lg-4 bx--col-md-2 bx--col-sm-4">
            <LMTile
              id="01"
              className="HH"
              bodyText="learnMore_tile04_text"
              functionToExecute={experienceProducts}
            />
          </div>
        </div>
      </div>
    </>
  );
};
